import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from './mustMatch';
import { ToastrService } from 'ngx-toastr';
import { TokenStorageService } from '../../../shared/services/authentication/token-storage.service';
import { Account, AccountUpdate, Password } from 'src/app/models/pubModel/account.model';
import { AccountService } from 'src/app/shared/services/admServices/accounts.service';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';

@Component({
  selector: 'pub-profile-component',
  templateUrl: './profile-component.html',
  styleUrls: ['./profile-component.scss']
})
export class pubprofileComponent implements OnInit {
  public passwordForm: FormGroup;
  public profileForm: FormGroup;

  currentUser: any;
  currentAccount = new Account();
  currentAccountUpdate = new  AccountUpdate();
  password = new Password()
  countryData: any;
  urlImage: any;
  flag: any;

  constructor(private fb: FormBuilder,
    private fbpro: FormBuilder,
    private toastrService: ToastrService,
    private tokenStorage: TokenStorageService,
    private accountService: AccountService,
    private sharedServices: SharedService) {

    this.currentUser = this.tokenStorage.getUser();

  }

  ngOnInit() {
    this.getAccount();
    this.getCountries();

    this.createPasswordForm();
    this.createProfileForm();
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countryData = data.data.countries;
     },
     error => {
       console.log(error);
     });
  }

  createPasswordForm() {
    this.passwordForm = this.fb.group({
      passwordCurrent: ['', [Validators.required, Validators.minLength(8)]],
      passwordNew: [null, [Validators.required, Validators.minLength(8)]],
      confirmPassword: [null, Validators.required],
    }, {
      validator: MustMatch('passwordNew', 'confirmPassword')
    });
  }

  createProfileForm(){
    this.profileForm = this.fbpro.group({
      userName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      company: [''],
      tax: [''],
      street: ['', Validators.required],
      cityName: ['', Validators.required],
      zip: ['', Validators.required],
      country: [null, Validators.required],
      note: [null]
    });
  }

  setFlag(event){
    this.flag = this.countryData[this.profileForm.get('country')!.value-1].alpha2Code;
  }

  setProfileForm(){
    this.profileForm.setValue({
      userName: this.currentAccount.username,
      firstName: this.currentAccount.firstName,
      lastName: this.currentAccount.lastName,
      email: this.currentAccount.email,
      company: this.currentAccount.company,
      tax: this.currentAccount.tax,
      street: this.currentAccount.address,
      zip: this.currentAccount.zipCode,
      cityName: this.currentAccount.city,
      country: this.currentAccount.country.id,
      note: this.currentAccount.about,
    });
    this.flag = this.currentAccount.country.alpha2Code;
  }

  getAccount(): void {
    this.accountService.getMyProfilePublisher()
      .subscribe(
        data => {
          this.currentAccount = data.data;

          if(this.currentAccount.profileImage==null)
            this.urlImage = '../../../../../assets/images/user/user2.png'
          else
            this.urlImage = this.currentAccount.profileImage;

            this.setProfileForm();
        },
        error => {
          console.log(error);
        });
  }

  onSave() {
    this.password.currentPassword = this.passwordForm.get('passwordCurrent')!.value;
    this.password.repeatNewPassword = this.passwordForm.get('confirmPassword')!.value;
    this.password.newPassword = this.passwordForm.get('passwordNew')!.value;

    this.accountService.changePass(this.password)
    .subscribe(
      data => {
        if(data.errors)
        {
          // error
          this.passwordForm.reset();
          this.toastrService.error(data.errors[0].message, 'Error !');
        }
        else
        {
          // poprawnie zmieniono hasło
          this.toastrService.success('New password properly changed.', 'Success !');
          this.passwordForm.reset();
        }
      },
      error => {
        console.log(error);
        this.toastrService.error('Change password failed.', 'Error');
      });

  }

  onUpdate() {
    this.currentAccountUpdate.username = this.profileForm.get('userName')!.value;
    this.currentAccountUpdate.firstName = this.profileForm.get('firstName')!.value;
    this.currentAccountUpdate.lastName = this.profileForm.get('lastName')!.value;
    this.currentAccountUpdate.email = this.profileForm.get('email')!.value;
    this.currentAccountUpdate.company = this.profileForm.get('company')!.value;
    this.currentAccountUpdate.tax = this.profileForm.get('tax')!.value;
    this.currentAccountUpdate.address = this.profileForm.get('street')!.value;
    this.currentAccountUpdate.zipCode = this.profileForm.get('zip')!.value;
    this.currentAccountUpdate.city = this.profileForm.get('cityName')!.value;
    this.currentAccountUpdate.about = this.profileForm.get('note')!.value;
    this.currentAccountUpdate.countryId = this.profileForm.get('country')!.value;

    this.accountService.updateMyProfilePublisher(this.currentAccountUpdate)
    .subscribe(
      data => {
        this.toastrService.success('Profile data updated.', 'Success !');
      },
      error => {
        console.log(error);
      });
  }

}
